"use client";

/**
 * This component serves as a wrapper around Next.js Image component to provide
 * a centralized point for image handling across the application. It maintains
 * full compatibility with the Next.js Image API while allowing for future
 * enhancements like analytics, error handling, and performance optimizations
 * without breaking existing implementations.
 */

import NextImage from "next/image";
import React from "react";
import { cn } from "@/lib/utils";
import ImageCaption from "./ImageCaption";

type NextImageActualProps = React.ComponentProps<typeof NextImage>;

interface ResponsiveImageCustomProps {
  caption?: string;
  allowCaption?: boolean;
}

type ResponsiveImageProps = NextImageActualProps & ResponsiveImageCustomProps;

const ResponsiveImage = React.forwardRef<React.ElementRef<typeof NextImage>, ResponsiveImageProps>(
  ({ caption, allowCaption = true, className, ...props }, ref) => {
    const shouldShowCaptionButton = caption && allowCaption;

    const wrapperClassName = cn("relative", props.fill ? "w-full h-full" : "inline-block");

    return (
      <div className={wrapperClassName}>
        <NextImage ref={ref} className={cn(className)} {...props} />

        {/* TODO: Add caption button back in */}
        {/* {shouldShowCaptionButton && (
        <ImageCaption caption={caption} />
      )} */}
      </div>
    );
  }
);

ResponsiveImage.displayName = "ResponsiveImage";

export default ResponsiveImage;
